// extracted by mini-css-extract-plugin
export default {"root":"q13fkSrq","content":"SqzmFQP8","blinkCursor":"h1h8OGWC","done":"J2mf0uT_","previewRow":"d0GvCaIy","previewDot":"s8fEOPJS","previewText":"SBdlGWcf"};